<template>
    <div id="country-selector" class="country-picker">
        <div v-if="getIsLoadingGeography">Loading</div>

        <multiselect
            v-else
            :class="[customClass, { 'country-picker--error': error }]"
            class="country-picker__control"
            v-model="selectedCountry"
            :options="countryOptions"
            :allowEmpty="allowEmpty"
            :multiple="false"
            group-values="allCountries"
            :showLabels="false"
            group-label="groupName"
            :placeholder="placeholder"
            track-by="id"
            label="name"
            :openDirection="openDirection"
            :disabled="disabled"
        >
        </multiselect>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { TOP_COUNTRY_CODES } from '@/enums/topCountries';
export default {
    data() {
        return {}
    },
    props: {
        allCountriesOption: {
            type: Boolean,
            default: false
        },
        openDirection: {
            type: String,
            default: 'bottom'
        },
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        allowEmpty: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Select Country'
        },
        selectedCountryValue: {
            type: Object,
            default: null
        },
        topCodes: {
            type: Array,
            default() {
                return TOP_COUNTRY_CODES;
            }
        },
    },
    created() {
        if (!this.getIsLoadingGeography && (!this.getCountries || !this.getCountries.length)) {
            this.$store.dispatch('initGeography');
        }
    },
    computed: {
        ...mapGetters([
            'getCountries',
            'getIsLoadingGeography'
        ]),
        selectedCountry: {
            get() {
                return this.selectedCountryValue;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        countryOptions() {
            // Filter top 5 codes
            const topCountries = this.getCountries.filter(c => this.topCodes.includes(c.code2));
            const allCountries = this.getCountries;
            const finalCountries = [
                {
                    groupName: 'Top 5 - Countries',
                    allCountries: topCountries
                },
                {
                    groupName: 'All Countries',
                    allCountries: allCountries
                }
            ];

            if (this.allCountriesOption) {
                finalCountries.unshift({
                    groupName: 'All Countries',
                    allCountries: [{
                        id: '__ALL__',
                        name: "All Countries"
                    }],
                })
            }
            
            return finalCountries;
        }
    },
    components: {
        Multiselect
    }
}
</script>

<style lang="scss">
    #country-selector.country-picker {
        position: relative;

        .country-picker__control { 
            height: 30px; 
        }

        .country-picker--error {
            border-color: #f16c64 !important;
        }

        .multiselect__select {
            top: 1px !important;
        }

        .multiselect__tags{
            background: none !important;
            border: 0 !important;
        }

        .multiselect__input {
            padding-top: 0.07rem !important;
        }

        .multiselect__placeholder {
            padding-top: 0.313rem !important;
        }
    }
</style>



// WEBPACK FOOTER //
// CountryPicker.vue?5f92a591